import { IRigAvailability } from '../../interfaces/irig-availability';
import { Rig } from '../rig';
import { Scenario } from '../scenario';

export class RigAvailabilityBase {
  RigAvailabilityId: number;
  RigId: number | null;
  StartDate: Date;
  EndDate: Date;
  IsJointVenture: boolean;
  JointVentureEffectiveDate: Date | null;
  IsSynced: boolean;
  ScenarioId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Rig?: Rig;
  Scenario?: Scenario;

  constructor(item?: IRigAvailability) {
    if (item) {

      this.RigAvailabilityId = item.RigAvailabilityId;
      this.RigId = item.RigId;
      this.StartDate = item.StartDate ? new Date(item.StartDate) : null;
      this.EndDate = item.EndDate ? new Date(item.EndDate) : null;
      this.IsJointVenture = item.IsJointVenture;
      this.JointVentureEffectiveDate = item.JointVentureEffectiveDate ? new Date(item.JointVentureEffectiveDate) : null;
      this.IsSynced = item.IsSynced;
      this.ScenarioId = item.ScenarioId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Rig = new Rig(item.Rig);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}